/* eslint-disable */
// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.5
// Generated from `ActApplyStruct.jce'
// **********************************************************************

var HUYA = HUYA || {};


HUYA.UserId = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sToken = "";
    this.sHuYaUA = "";
    this.sCookie = "";
    this.iTokenType = 0;
};
HUYA.UserId.prototype._clone = function () { return new HUYA.UserId(); }
HUYA.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserId.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserId.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sToken);
    os.writeString(3, this.sHuYaUA);
    os.writeString(4, this.sCookie);
    os.writeInt32(5, this.iTokenType);
};

HUYA.UserId.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sToken= is.readString(2, false, this.sToken);
    this.sHuYaUA= is.readString(3, false, this.sHuYaUA);
    this.sCookie= is.readString(4, false, this.sCookie);
    this.iTokenType= is.readInt32(5, false, this.iTokenType);
};

var ActApply = ActApply || {};


ActApply.EApplyStatus = 
{
    AllowApply : 0,
    ForbidApply : 1,
    AlreadyApply : 2
};

ActApply.JumpChannel = function()
{
    this.lPid = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.iGameId = 0;
    this.lYYId = 0;
    this.iRoomId = 0;
};
ActApply.JumpChannel.prototype._clone = function () { return new ActApply.JumpChannel(); }
ActApply.JumpChannel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.JumpChannel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.JumpChannel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lTid);
    os.writeInt64(2, this.lSid);
    os.writeInt32(3, this.iGameId);
    os.writeInt64(4, this.lYYId);
    os.writeInt32(5, this.iRoomId);
};

ActApply.JumpChannel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(2, false, this.lSid);
    this.iGameId= is.readInt32(3, false, this.iGameId);
    this.lYYId= is.readInt64(4, false, this.lYYId);
    this.iRoomId= is.readInt32(5, false, this.iRoomId);
};

ActApply.ApplyConfigReq = function()
{
    this.lPid = 0;
    this.lActId = 0;
};
ActApply.ApplyConfigReq.prototype._clone = function () { return new ActApply.ApplyConfigReq(); }
ActApply.ApplyConfigReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.ApplyConfigReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.ApplyConfigReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lActId);
};

ActApply.ApplyConfigReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.lActId= is.readInt64(1, false, this.lActId);
};

ActApply.AreaItem = function()
{
    this.iAreaId = 0;
    this.sName = "";
    this.iStatus = 0;
};
ActApply.AreaItem.prototype._clone = function () { return new ActApply.AreaItem(); }
ActApply.AreaItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.AreaItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.AreaItem.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeString(1, this.sName);
    os.writeInt32(2, this.iStatus);
};

ActApply.AreaItem.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.sName= is.readString(1, false, this.sName);
    this.iStatus= is.readInt32(2, false, this.iStatus);
};

ActApply.ApplyConfigRsp = function()
{
    this.iResult = 0;
    this.vAreaList = new Taf.Vector(new ActApply.AreaItem());
    this.iApplyAreaId = 0;
    this.iRoleType = 0;
    this.iAllowApply = 0;
};
ActApply.ApplyConfigRsp.prototype._clone = function () { return new ActApply.ApplyConfigRsp(); }
ActApply.ApplyConfigRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.ApplyConfigRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.ApplyConfigRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iResult);
    os.writeVector(1, this.vAreaList);
    os.writeInt32(2, this.iApplyAreaId);
    os.writeInt32(3, this.iRoleType);
    os.writeInt32(4, this.iAllowApply);
};

ActApply.ApplyConfigRsp.prototype.readFrom = function (is)
{
    this.iResult= is.readInt32(0, false, this.iResult);
    this.vAreaList= is.readVector(1, false, this.vAreaList);
    this.iApplyAreaId= is.readInt32(2, false, this.iApplyAreaId);
    this.iRoleType= is.readInt32(3, false, this.iRoleType);
    this.iAllowApply= is.readInt32(4, false, this.iAllowApply);
};

ActApply.ApplyReq = function()
{
    this.lPid = 0;
    this.lActId = 0;
    this.iAreaId = 0;
};
ActApply.ApplyReq.prototype._clone = function () { return new ActApply.ApplyReq(); }
ActApply.ApplyReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.ApplyReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.ApplyReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lActId);
    os.writeInt32(2, this.iAreaId);
};

ActApply.ApplyReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.lActId= is.readInt64(1, false, this.lActId);
    this.iAreaId= is.readInt32(2, false, this.iAreaId);
};

ActApply.ApplyRsp = function()
{
    this.iAreaId = 0;
    this.iResult = 0;
    this.sMsg = "";
};
ActApply.ApplyRsp.prototype._clone = function () { return new ActApply.ApplyRsp(); }
ActApply.ApplyRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.ApplyRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.ApplyRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iResult);
    os.writeString(2, this.sMsg);
};

ActApply.ApplyRsp.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iResult= is.readInt32(1, false, this.iResult);
    this.sMsg= is.readString(2, false, this.sMsg);
};

ActApply.CancleApplyReq = function()
{
    this.lPid = 0;
    this.lActId = 0;
};
ActApply.CancleApplyReq.prototype._clone = function () { return new ActApply.CancleApplyReq(); }
ActApply.CancleApplyReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.CancleApplyReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.CancleApplyReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lActId);
};

ActApply.CancleApplyReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.lActId= is.readInt64(1, false, this.lActId);
};

ActApply.CancleApplyRsp = function()
{
    this.iResult = 0;
    this.sMsg = "";
};
ActApply.CancleApplyRsp.prototype._clone = function () { return new ActApply.CancleApplyRsp(); }
ActApply.CancleApplyRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.CancleApplyRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.CancleApplyRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iResult);
    os.writeString(1, this.sMsg);
};

ActApply.CancleApplyRsp.prototype.readFrom = function (is)
{
    this.iResult= is.readInt32(0, false, this.iResult);
    this.sMsg= is.readString(1, false, this.sMsg);
};

ActApply.ActSearchUserReq = function()
{
    this.lUid = 0;
    this.sNickName = "";
    this.iTimes = 0;
    this.lActId = 0;
};
ActApply.ActSearchUserReq.prototype._clone = function () { return new ActApply.ActSearchUserReq(); }
ActApply.ActSearchUserReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.ActSearchUserReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.ActSearchUserReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
    os.writeInt32(2, this.iTimes);
    os.writeInt64(3, this.lActId);
};

ActApply.ActSearchUserReq.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.iTimes= is.readInt32(2, false, this.iTimes);
    this.lActId= is.readInt64(3, false, this.lActId);
};

ActApply.AssistRankItem = function()
{
    this.lPid = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
    this.iRoleType = 0;
    this.lScore = 0;
    this.iOperatorType = 0;
    this.iSubscription = 0;
};
ActApply.AssistRankItem.prototype._clone = function () { return new ActApply.AssistRankItem(); }
ActApply.AssistRankItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.AssistRankItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.AssistRankItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sLogoUrl);
    os.writeInt32(3, this.iRoleType);
    os.writeInt64(4, this.lScore);
    os.writeInt32(5, this.iOperatorType);
    os.writeInt32(6, this.iSubscription);
};

ActApply.AssistRankItem.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.sLogoUrl= is.readString(2, false, this.sLogoUrl);
    this.iRoleType= is.readInt32(3, false, this.iRoleType);
    this.lScore= is.readInt64(4, false, this.lScore);
    this.iOperatorType= is.readInt32(5, false, this.iOperatorType);
    this.iSubscription= is.readInt32(6, false, this.iSubscription);
};

ActApply.ActSearchUserRsp = function()
{
    this.vItems = new Taf.Vector(new ActApply.AssistRankItem());
};
ActApply.ActSearchUserRsp.prototype._clone = function () { return new ActApply.ActSearchUserRsp(); }
ActApply.ActSearchUserRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.ActSearchUserRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.ActSearchUserRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vItems);
};

ActApply.ActSearchUserRsp.prototype.readFrom = function (is)
{
    this.vItems= is.readVector(0, false, this.vItems);
};

ActApply.InviteListReq = function()
{
    this.lUid = 0;
    this.lActId = 0;
};
ActApply.InviteListReq.prototype._clone = function () { return new ActApply.InviteListReq(); }
ActApply.InviteListReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.InviteListReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.InviteListReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lActId);
};

ActApply.InviteListReq.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lActId= is.readInt64(1, false, this.lActId);
};

ActApply.InviteListRsp = function()
{
    this.vInviteList = new Taf.Vector(new ActApply.AssistRankItem());
    this.vInviteeList = new Taf.Vector(new ActApply.AssistRankItem());
};
ActApply.InviteListRsp.prototype._clone = function () { return new ActApply.InviteListRsp(); }
ActApply.InviteListRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.InviteListRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.InviteListRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vInviteList);
    os.writeVector(1, this.vInviteeList);
};

ActApply.InviteListRsp.prototype.readFrom = function (is)
{
    this.vInviteList= is.readVector(0, false, this.vInviteList);
    this.vInviteeList= is.readVector(1, false, this.vInviteeList);
};

ActApply.InviteAssistReq = function()
{
    this.lInviteUid = 0;
    this.lInviteeUid = 0;
    this.lActId = 0;
};
ActApply.InviteAssistReq.prototype._clone = function () { return new ActApply.InviteAssistReq(); }
ActApply.InviteAssistReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.InviteAssistReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.InviteAssistReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lInviteUid);
    os.writeInt64(1, this.lInviteeUid);
    os.writeInt64(2, this.lActId);
};

ActApply.InviteAssistReq.prototype.readFrom = function (is)
{
    this.lInviteUid= is.readInt64(0, false, this.lInviteUid);
    this.lInviteeUid= is.readInt64(1, false, this.lInviteeUid);
    this.lActId= is.readInt64(2, false, this.lActId);
};

ActApply.InviteAssistRsp = function()
{
    this.iResult = 0;
    this.sMsg = "";
};
ActApply.InviteAssistRsp.prototype._clone = function () { return new ActApply.InviteAssistRsp(); }
ActApply.InviteAssistRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.InviteAssistRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.InviteAssistRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iResult);
    os.writeString(1, this.sMsg);
};

ActApply.InviteAssistRsp.prototype.readFrom = function (is)
{
    this.iResult= is.readInt32(0, false, this.iResult);
    this.sMsg= is.readString(1, false, this.sMsg);
};

ActApply.ResponInviteReq = function()
{
    this.lInviteeUid = 0;
    this.lInviteUid = 0;
    this.lActId = 0;
    this.iOperatorType = 0;
};
ActApply.ResponInviteReq.prototype._clone = function () { return new ActApply.ResponInviteReq(); }
ActApply.ResponInviteReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.ResponInviteReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.ResponInviteReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lInviteeUid);
    os.writeInt64(1, this.lInviteUid);
    os.writeInt64(2, this.lActId);
    os.writeInt32(3, this.iOperatorType);
};

ActApply.ResponInviteReq.prototype.readFrom = function (is)
{
    this.lInviteeUid= is.readInt64(0, false, this.lInviteeUid);
    this.lInviteUid= is.readInt64(1, false, this.lInviteUid);
    this.lActId= is.readInt64(2, false, this.lActId);
    this.iOperatorType= is.readInt32(3, false, this.iOperatorType);
};

ActApply.ResponInviteRsp = function()
{
    this.iResult = 0;
    this.sMsg = "";
};
ActApply.ResponInviteRsp.prototype._clone = function () { return new ActApply.ResponInviteRsp(); }
ActApply.ResponInviteRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.ResponInviteRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.ResponInviteRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iResult);
    os.writeString(1, this.sMsg);
};

ActApply.ResponInviteRsp.prototype.readFrom = function (is)
{
    this.iResult= is.readInt32(0, false, this.iResult);
    this.sMsg= is.readString(1, false, this.sMsg);
};

ActApply.RelieveRelationshipReq = function()
{
    this.lOperPid = 0;
    this.lRelievePid = 0;
    this.lActId = 0;
};
ActApply.RelieveRelationshipReq.prototype._clone = function () { return new ActApply.RelieveRelationshipReq(); }
ActApply.RelieveRelationshipReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.RelieveRelationshipReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.RelieveRelationshipReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lOperPid);
    os.writeInt64(1, this.lRelievePid);
    os.writeInt64(2, this.lActId);
};

ActApply.RelieveRelationshipReq.prototype.readFrom = function (is)
{
    this.lOperPid= is.readInt64(0, false, this.lOperPid);
    this.lRelievePid= is.readInt64(1, false, this.lRelievePid);
    this.lActId= is.readInt64(2, false, this.lActId);
};

ActApply.RelieveRelationshipRsp = function()
{
    this.iResult = 0;
    this.sMsg = "";
};
ActApply.RelieveRelationshipRsp.prototype._clone = function () { return new ActApply.RelieveRelationshipRsp(); }
ActApply.RelieveRelationshipRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.RelieveRelationshipRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.RelieveRelationshipRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iResult);
    os.writeString(1, this.sMsg);
};

ActApply.RelieveRelationshipRsp.prototype.readFrom = function (is)
{
    this.iResult= is.readInt32(0, false, this.iResult);
    this.sMsg= is.readString(1, false, this.sMsg);
};

ActApply.AssistInfoReq = function()
{
    this.lUid = 0;
    this.lActId = 0;
    this.iRoleType = 0;
};
ActApply.AssistInfoReq.prototype._clone = function () { return new ActApply.AssistInfoReq(); }
ActApply.AssistInfoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.AssistInfoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.AssistInfoReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lActId);
    os.writeInt32(2, this.iRoleType);
};

ActApply.AssistInfoReq.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lActId= is.readInt64(1, false, this.lActId);
    this.iRoleType= is.readInt32(2, false, this.iRoleType);
};

ActApply.AssistInfoRsp = function()
{
    this.vAssistInfo = new ActApply.AssistRankItem();
};
ActApply.AssistInfoRsp.prototype._clone = function () { return new ActApply.AssistInfoRsp(); }
ActApply.AssistInfoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.AssistInfoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.AssistInfoRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.vAssistInfo);
};

ActApply.AssistInfoRsp.prototype.readFrom = function (is)
{
    this.vAssistInfo= is.readStruct(0, false, this.vAssistInfo);
};

ActApply.GuildApplyConfigReq = function()
{
    this.lActId = 0;
    this.tUserId = new HUYA.UserId();
};
ActApply.GuildApplyConfigReq.prototype._clone = function () { return new ActApply.GuildApplyConfigReq(); }
ActApply.GuildApplyConfigReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.GuildApplyConfigReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.GuildApplyConfigReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lActId);
    os.writeStruct(1, this.tUserId);
};

ActApply.GuildApplyConfigReq.prototype.readFrom = function (is)
{
    this.lActId= is.readInt64(0, false, this.lActId);
    this.tUserId= is.readStruct(1, false, this.tUserId);
};

ActApply.GuildAreaItem = function()
{
    this.iAreaId = 0;
    this.sAreaName = "";
};
ActApply.GuildAreaItem.prototype._clone = function () { return new ActApply.GuildAreaItem(); }
ActApply.GuildAreaItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.GuildAreaItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.GuildAreaItem.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeString(1, this.sAreaName);
};

ActApply.GuildAreaItem.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.sAreaName= is.readString(1, false, this.sAreaName);
};

ActApply.GuildApplyConfigRsp = function()
{
    this.lApplyStartTime = 0;
    this.lApplyEndTime = 0;
    this.lMatchStartTime = 0;
    this.vAreaList = new Taf.Vector(new ActApply.GuildAreaItem());
};
ActApply.GuildApplyConfigRsp.prototype._clone = function () { return new ActApply.GuildApplyConfigRsp(); }
ActApply.GuildApplyConfigRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.GuildApplyConfigRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.GuildApplyConfigRsp.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lApplyStartTime);
    os.writeInt64(1, this.lApplyEndTime);
    os.writeInt64(2, this.lMatchStartTime);
    os.writeVector(3, this.vAreaList);
};

ActApply.GuildApplyConfigRsp.prototype.readFrom = function (is)
{
    this.lApplyStartTime= is.readInt64(0, false, this.lApplyStartTime);
    this.lApplyEndTime= is.readInt64(1, false, this.lApplyEndTime);
    this.lMatchStartTime= is.readInt64(2, false, this.lMatchStartTime);
    this.vAreaList= is.readVector(3, false, this.vAreaList);
};

ActApply.GuildApplyInfoReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.lGuildId = 0;
    this.lActId = 0;
};
ActApply.GuildApplyInfoReq.prototype._clone = function () { return new ActApply.GuildApplyInfoReq(); }
ActApply.GuildApplyInfoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.GuildApplyInfoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.GuildApplyInfoReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserId);
    os.writeInt64(1, this.lGuildId);
    os.writeInt64(2, this.lActId);
};

ActApply.GuildApplyInfoReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(0, false, this.tUserId);
    this.lGuildId= is.readInt64(1, false, this.lGuildId);
    this.lActId= is.readInt64(2, false, this.lActId);
};

ActApply.GuildApplyInfoRsp = function()
{
    this.iAreaId = 0;
    this.vAreaList = new Taf.Vector(new Taf.INT32());
};
ActApply.GuildApplyInfoRsp.prototype._clone = function () { return new ActApply.GuildApplyInfoRsp(); }
ActApply.GuildApplyInfoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.GuildApplyInfoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.GuildApplyInfoRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeVector(1, this.vAreaList);
};

ActApply.GuildApplyInfoRsp.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.vAreaList= is.readVector(1, false, this.vAreaList);
};

ActApply.GuildApplyReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.lGuildId = 0;
    this.iAreaId = 0;
    this.lActId = 0;
};
ActApply.GuildApplyReq.prototype._clone = function () { return new ActApply.GuildApplyReq(); }
ActApply.GuildApplyReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.GuildApplyReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.GuildApplyReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserId);
    os.writeInt64(1, this.lGuildId);
    os.writeInt32(2, this.iAreaId);
    os.writeInt64(3, this.lActId);
};

ActApply.GuildApplyReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(0, false, this.tUserId);
    this.lGuildId= is.readInt64(1, false, this.lGuildId);
    this.iAreaId= is.readInt32(2, false, this.iAreaId);
    this.lActId= is.readInt64(3, false, this.lActId);
};

ActApply.GuildApplyRsp = function()
{
    this.iRspCode = 0;
    this.sRspDesc = "";
    this.lGuildId = 0;
    this.sGuildName = "";
    this.sAreaName = "";
    this.lGuildNo = 0;
    this.lMatchStartTime = 0;
};
ActApply.GuildApplyRsp.prototype._clone = function () { return new ActApply.GuildApplyRsp(); }
ActApply.GuildApplyRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.GuildApplyRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.GuildApplyRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRspCode);
    os.writeString(1, this.sRspDesc);
    os.writeInt64(2, this.lGuildId);
    os.writeString(3, this.sGuildName);
    os.writeString(4, this.sAreaName);
    os.writeInt64(5, this.lGuildNo);
    os.writeInt64(6, this.lMatchStartTime);
};

ActApply.GuildApplyRsp.prototype.readFrom = function (is)
{
    this.iRspCode= is.readInt32(0, false, this.iRspCode);
    this.sRspDesc= is.readString(1, false, this.sRspDesc);
    this.lGuildId= is.readInt64(2, false, this.lGuildId);
    this.sGuildName= is.readString(3, false, this.sGuildName);
    this.sAreaName= is.readString(4, false, this.sAreaName);
    this.lGuildNo= is.readInt64(5, false, this.lGuildNo);
    this.lMatchStartTime= is.readInt64(6, false, this.lMatchStartTime);
};

ActApply.GuildListReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.lActId = 0;
};
ActApply.GuildListReq.prototype._clone = function () { return new ActApply.GuildListReq(); }
ActApply.GuildListReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.GuildListReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.GuildListReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserId);
    os.writeInt64(1, this.lActId);
};

ActApply.GuildListReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(0, false, this.tUserId);
    this.lActId= is.readInt64(1, false, this.lActId);
};

ActApply.GuildApplyItem = function()
{
    this.lGuildId = 0;
    this.sGuildName = "";
    this.iAreaId = 0;
    this.lGuildNo = 0;
};
ActApply.GuildApplyItem.prototype._clone = function () { return new ActApply.GuildApplyItem(); }
ActApply.GuildApplyItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.GuildApplyItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.GuildApplyItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lGuildId);
    os.writeString(1, this.sGuildName);
    os.writeInt32(2, this.iAreaId);
    os.writeInt64(3, this.lGuildNo);
};

ActApply.GuildApplyItem.prototype.readFrom = function (is)
{
    this.lGuildId= is.readInt64(0, false, this.lGuildId);
    this.sGuildName= is.readString(1, false, this.sGuildName);
    this.iAreaId= is.readInt32(2, false, this.iAreaId);
    this.lGuildNo= is.readInt64(3, false, this.lGuildNo);
};

ActApply.GuildListRsp = function()
{
    this.vList = new Taf.Vector(new ActApply.GuildApplyItem());
};
ActApply.GuildListRsp.prototype._clone = function () { return new ActApply.GuildListRsp(); }
ActApply.GuildListRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActApply.GuildListRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActApply.GuildListRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vList);
};

ActApply.GuildListRsp.prototype.readFrom = function (is)
{
    this.vList= is.readVector(0, false, this.vList);
};

export default ActApply;